export class NextConfig {
  public static config = {
    layout: 'horizontal', // vertical, horizontal
    subLayout: 'horizontal-2', // horizontal-2
    collapseMenu: false,
    layoutType: 'menu-light', // menu-dark, menu-light, dark
    headerBackColor: 'header-red', // header-default, header-blue, header-red, header-purple, header-info, header-dark
    navBrandColor: 'brand-red', // brand-default, brand-blue, brand-red, brand-purple, brand-info, brand-dark
    rtlLayout: false,
    navFixedLayout: true,
    headerFixedLayout: true,
    boxLayout: false,
  };
}
